import { render, staticRenderFns } from "./TrackingInitiative.vue?vue&type=template&id=06ef1f1a&scoped=true&"
import script from "./TrackingInitiative.vue?vue&type=script&lang=ts&"
export * from "./TrackingInitiative.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ef1f1a",
  null
  
)

export default component.exports